// Shared display constants + helpers for the Orders & Invoices module.
export const STATUSES = ["pending_approval", "approved", "processing", "shipped", "completed", "rejected", "cancelled"];

export const STATUS_LABELS = {
  pending_approval: "Pending Approval", approved: "Approved", processing: "Processing",
  shipped: "Shipped", completed: "Completed", rejected: "Rejected", cancelled: "Cancelled",
};

export const STYLE = {
  pending_approval: "bg-[#FBF1DF] text-[#7A4B12] border border-[#E7D0A8]",
  approved: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  processing: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  shipped: "bg-[#EDE7F7] text-[#4B2E7A] border border-[#D0C7E7]",
  completed: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  rejected: "bg-[#FBE7E7] text-[#7A1F1F] border border-[#E7B9B9]",
  cancelled: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
};

export const PAYMENT_STYLE = {
  paid: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  partial: "bg-[#FBF1DF] text-[#7A4B12] border border-[#E7D0A8]",
  unpaid: "bg-[#FBE7E7] text-[#7A1F1F] border border-[#E7B9B9]",
  overdue: "bg-[#F8D7D7] text-[#7A1F1F] border border-[#E29B9B]",
  not_invoiced: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
  not_applicable: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
};
export const PAYMENT_LABELS = { paid: "Paid", partial: "Partial", unpaid: "Unpaid", not_invoiced: "Not Invoiced", not_applicable: "N/A" };

export const INVOICE_STYLE = {
  draft: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
  issued: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  cancelled: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
};
export const INVOICE_LABELS = { draft: "Draft", issued: "Issued", cancelled: "Cancelled" };

// Metal (Gold) Status — Invoices tab, driven by the Gold ledger side (fine 24K grams),
// independent of the Rupee side. "Paid in Gold" / "Partial Gold Paid" per the business spec.
export const GOLD_STATUS_LABELS = { paid: "Paid in Gold", partial: "Partial Gold Paid", unpaid: "Unpaid", not_applicable: "N/A", not_invoiced: "Not Invoiced" };
export const GOLD_STATUS_STYLE = PAYMENT_STYLE;

// Rupee Status — Invoices tab, mirrors the existing payment_status (Unpaid/Partial/Paid).
export const RUPEE_STATUS_LABELS = { paid: "Paid", partial: "Partial", unpaid: "Unpaid", not_invoiced: "Not Invoiced" };
export const RUPEE_STATUS_STYLE = PAYMENT_STYLE;

// Orders tab: the full 7-stage backend pipeline collapses into 3 visible buckets —
// Pending (pending_approval), In Progress (approved + processing), Ready (shipped).
// Completed/Rejected/Cancelled orders never show in the Orders tab.
export const ORDER_TAB_STATUSES = ["pending_approval", "approved", "processing", "shipped"];
// Virtual tab VALUES for the Orders-tab status filter UI — "in_progress" is a merged
// bucket (approved + processing) that doesn't exist as a literal backend status; the
// page filters client-side for it instead of sending it to the API as a `status` param.
export const ORDER_TAB_FILTER_OPTIONS = ["pending_approval", "in_progress", "shipped"];
export const SIMPLE_STATUS_LABELS = { pending_approval: "Pending", in_progress: "In Progress", approved: "In Progress", processing: "In Progress", shipped: "Ready" };
export const SIMPLE_STATUS_STYLE = {
  pending_approval: "bg-[#FBF1DF] text-[#7A4B12] border border-[#E7D0A8]",
  in_progress: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  approved: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  processing: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  shipped: "bg-[#EDE7F7] text-[#4B2E7A] border border-[#D0C7E7]",
};

// Karat -> fine (24K) factor, mirrors backend pricing_engine.KARAT_PURITY (used for live metal-payment preview)
export const KARAT_FACTORS = { "24K": 1.0, "22K": 0.916, "18K": 0.75, "14K": 0.585, "9K": 0.375 };
export const fmtGrams = (g) => `${(Number(g) || 0).toFixed(3)} g`;
